<template>
  <NuxtPage v-if="currentSite" />
  <UNotifications />
</template>

<script setup>
  const { data: currentSite } = await useApi("/api/sites")
  provide("currentSite", currentSite)

  const {
    inAgeRestrictedLocation,
    country: geoCountry,
    region: geoRegion,
  } = useGeoLocation()

  provide("inAgeRestrictedLocation", inAgeRestrictedLocation)
  provide("geoCountry", geoCountry)
  provide("geoRegion", geoRegion)

  // For handling release card hovers so that
  // only ever one is playing.
  const activeReleaseCardHover = ref(null)
  provide("activeReleaseCardHover", activeReleaseCardHover)

  if (currentSite.value) {
    useHead({
      link: [
        {
          rel: "icon",
          type: "image/x-icon",
          href: `/images/sites/${currentSite.value.slug}/${currentSite.value.slug}-favicon.ico`,
        },
      ],
    })
  }

  const userStore = useUserStore()
  onMounted(() => {
    useBugsnag().setUser({
      id: userStore.id,
      username: userStore.username,
      expected: userStore.expected,
      trial: userStore.trial,
      hasLifetime: userStore.hasLifetime,
    })
  })
</script>
